import React                      from 'react'
import { Button
       , Empty
       , Layout
       , Radio }                  from 'antd'
import { Observer }               from 'mobx-react'

import { TEXT
       , tr }                     from '../00_assets'
import { MApp }                   from '../09_model_app'
import { create_user_modal
       , Toolbar }                from '../10_ui'


import { MWorkGroups
       , WORKGROUP_TAB }          from './01_screen_workgroups_model'
import { WorkgroupsList }         from './03_screen_workgroups_list'
import { WorkgroupUsersTable }    from './04_screen_workgroups_users'
import { create_machine_modal 
       , WorkgroupMachinesTable } from './06_screen_workgroups_machines'


export const WorkgroupsScreen: React.FC = () => {
  return (
  <Layout className="layout">
    <WorkgroupsList />
    <WorkgroupsDetail />
  </Layout>
  );
}


const WorkgroupsDetail: React.FC = () =>
<Observer render={ ( ) =>
{
  const model   = MWorkGroups.instance( )
      , src     = model.users.data_for_page( 0 )
      , on_create_element = ( ) =>
        {
          if ( model.workgroup_tab === WORKGROUP_TAB.USERS )
               create_user_modal( model.users.on_add, model.selected_workgroup ) ;
          else if ( model.workgroup_tab === WORKGROUP_TAB.MACHINES )
               create_machine_modal( model.machines.on_add, model.selected_workgroup ) ;
        }

  return model.selected_workgroup === null?
          <Empty className="flex-col w-100 flex-justify-center" description={ tr( TEXT.UI_NO_DATA ) }/>
        : <Layout.Content className="scrollable">
            <Toolbar>
              <Radio.Group 
                className="mr-auto"
                value={ model.workgroup_tab }
                onChange={ model.on_change_workgroup_tab }
              >
                <Radio.Button value={ WORKGROUP_TAB.USERS }>{ tr( TEXT.UI_USERS ) }</Radio.Button>
                <Radio.Button value={ WORKGROUP_TAB.MACHINES }>{ tr( TEXT.UI_MACHINES ) }</Radio.Button>
              </Radio.Group>
              { 
                MApp( ).can_edit_workgroups?
                  <Button
                      disabled={ src.loading || model.selected_workgroup === null }
                      onClick={ on_create_element }
                      type="primary"
                  >
                    {
                    model.workgroup_tab === WORKGROUP_TAB.USERS?
                      tr( TEXT.USERS_NEW_TITLE )
                    : tr( TEXT.MACHINES_NEW )
                    }
                  </Button>
              : null
              }
            </Toolbar>
            { 
              model.workgroup_tab === WORKGROUP_TAB.USERS?
                <WorkgroupUsersTable />
              : <WorkgroupMachinesTable />
            }
          </Layout.Content> ;
} }/>